/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Change_PendingInputs */

const en_po_issue_change_pending = /** @type {(inputs: Po_Issue_Change_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`already has a proposal waiting for a decision`)
};

/**
* | output |
* | --- |
* | "already has a proposal waiting for a decision" |
*
* @param {Po_Issue_Change_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_change_pending = /** @type {((inputs?: Po_Issue_Change_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Change_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_change_pending(inputs)
});